import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export function SuccessMessageIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M16 4C9.38 4 4 9.38 4 16C4 22.62 9.38 28 16 28C22.62 28 28 22.62 28 16C28 9.38 22.62 4 16 4ZM16 26C10.48 26 6 21.52 6 16C6 10.48 10.48 6 16 6C21.52 6 26 10.48 26 16C26 21.52 21.52 26 16 26Z"
        fill="currentColor"
      />
      <path
        d="M12.9415 15.169L14.1779 16.2869C14.3447 16.4375 14.5976 16.4349 14.7594 16.2792L19.0878 12.1192C19.2597 11.9533 19.5353 11.961 19.6971 12.1396L20.8854 13.4387C21.0447 13.6122 21.0371 13.8827 20.8677 14.0461L14.8251 19.8803C14.6633 20.036 14.4079 20.0411 14.2411 19.888L11.1414 17.0525C10.9594 16.8866 10.9518 16.6008 11.1262 16.4272L12.355 15.1869C12.5168 15.0236 12.7747 15.0185 12.9441 15.1716L12.9415 15.169Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ErrorMessageIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M16 4C9.38 4 4 9.38 4 16C4 22.62 9.38 28 16 28C22.62 28 28 22.62 28 16C28 9.38 22.62 4 16 4ZM16 26C10.48 26 6 21.52 6 16C6 10.48 10.48 6 16 6C21.52 6 26 10.48 26 16C26 21.52 21.52 26 16 26Z"
        fill="currentColor"
      />
      <path
        d="M19.3069 12.0642L16.2427 15.1284L13.1785 12.0642L12.0642 13.1785L15.1284 16.2427L12.0642 19.3069L13.1785 20.4211L16.2427 17.3569L19.3069 20.4211L20.4211 19.3069L17.3569 16.2427L20.4211 13.1785L19.3069 12.0642Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function InfoMessageIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M16 4C9.38 4 4 9.38 4 16C4 22.62 9.38 28 16 28C22.62 28 28 22.62 28 16C28 9.38 22.62 4 16 4ZM16 26C10.48 26 6 21.52 6 16C6 10.48 10.48 6 16 6C21.52 6 26 10.48 26 16C26 21.52 21.52 26 16 26Z"
        fill="currentColor"
      />
      <path
        d="M16 13.7C15.44 13.7 15 14.14 15 14.7V21.5C15 22.06 15.44 22.5 16 22.5C16.56 22.5 17 22.06 17 21.5V14.7C17 14.16 16.56 13.7 16 13.7Z"
        fill="currentColor"
      />
      <path
        d="M16.02 9.59999C15.5 9.55999 15.02 10.1 15 10.64C15 10.66 15 10.78 15 10.8C15 11.34 15.42 11.74 15.98 11.76H16C16.54 11.76 16.98 11.28 17 10.76C17 10.74 17 10.54 17 10.54C17 9.95999 16.58 9.59999 16.02 9.59999Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function WarningMessageIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M16 28C22.62 28 28 22.62 28 16C28 9.38 22.62 4 16 4C9.38 4 4 9.38 4 16C4 22.62 9.38 28 16 28ZM16 6C21.52 6 26 10.48 26 16C26 21.52 21.52 26 16 26C10.48 26 6 21.52 6 16C6 10.48 10.48 6 16 6Z"
        fill="currentColor"
      />
      <path
        d="M16 18.3C16.56 18.3 17 17.86 17 17.3L17 10.5C17 9.94005 16.56 9.50005 16 9.50005C15.44 9.50005 15 9.94005 15 10.5L15 17.3C15 17.84 15.44 18.3 16 18.3Z"
        fill="currentColor"
      />
      <path
        d="M15.98 22.4C16.5 22.44 16.98 21.9 17 21.36C17 21.34 17 21.22 17 21.2C17 20.66 16.58 20.26 16.02 20.24L16 20.24C15.46 20.24 15.02 20.72 15 21.24C15 21.26 15 21.46 15 21.46C15 22.04 15.42 22.4 15.98 22.4Z"
        fill="currentColor"
      />
    </svg>
  );
}
